import React from 'react';

import {IHttpMonitorItem} from 'features/http/model/HttpMonitor/IHttpMonitor';
import useHttpMonitorAvgResponseTime from 'features/http/model/useHttpMonitorAvgResponseTime';
import ResponseTimeChart from 'shared/ui/ResponseTimeChart/ResponseTimeChart';

interface IHttpMonitorAvgResponseTimeChartProps {
    height: number,
    uuid?: string,
    item?: IHttpMonitorItem,
}

const HttpMonitorAvgResponseTimeChart: React.FC<IHttpMonitorAvgResponseTimeChartProps> = ({uuid, height, item}) => {
    const {data, isLoading, hasError, paused} = useHttpMonitorAvgResponseTime(uuid, item);

    return (
        <ResponseTimeChart
            data={data}
            height={height}
            isLoading={isLoading}
            hasError={hasError}
            paused={paused}
        />
    );
};

export default HttpMonitorAvgResponseTimeChart;
